//reducer for sharebot enable and disable

const initialState = {
    showShareBot: false,
    showAssistance: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'ENABLE_SHAREBOT':
            return { showShareBot: true, showAssistance: false };
        case 'DISABLE_SHAREBOT':
            return {
                ...state, showShareBot: false
            }
        case 'ENABLE_ASSISTANCE':
            return { showShareBot: false, showAssistance: true };
        case 'DISABLE_ASSISTANCE':
            return {
                ...state, showAssistance: false
            }
        default:
            return state
    }
}